export default {
  replaceProtocol(src) {
    return src ? src.replace(/^http:\/\//, "https://") : src
  },
}
